import React from "react";
import PageHero from "../components/PageHero";
import About from "../components/About";
import Ecosystem from "../components/Ecosystem";
import KprGroup from "../components/KprGroup";
import CampusLife from "../components/CampusLife";
import Leadership from "../components/Leadership";
import Institutions from "../components/Institutions";
import useSeo from "../hooks/useSeo";

export default function AboutPage() {
  useSeo({
    title: "About the Academy",
    path: "/about",
    description:
      "Growing by Giving - the philosophy behind The KPR Academy, Coimbatore. Learn about our vision, mission, five-decade KPR learning ecosystem and the leadership team led by Chairman Dr. K.P. Ramasamy.",
    keywords:
      "about KPR Academy, KPR Group education, Dr K P Ramasamy, Gayathri Anandakrishnan, CBSE school Coimbatore about, school vision mission",
  });
  return (
    <>
      <PageHero
        eyebrow="About the Academy"
        title="Growing by Giving — a philosophy, not a tagline"
        sub="An institution founded by a visionary with an unwavering belief that life's highest purpose is not only to take, but to give."
        crumbs={[{ label: "About" }]}
        image="/campus/school-3.jpg"
      />
      <About />
      <Ecosystem />
      <KprGroup />
      <CampusLife />
      <Leadership />
      <Institutions />
    </>
  );
}
